import { User } from '../models/user.model';

export interface IdTokenClaims {
  iss: string;
  sub: string;
  email: string;
  name?: string;
  given_name?: string;
  family_name?: string;
  hd?: string;
  exp: number;
  aud: string | string[];
}

export interface TokenResponse {
  access_token: string;
  id_token?: string;
  refresh_token?: string;
  token_type: string;
  expires_in: number;
  scope?: string;
}

/** Decodes a JWT payload segment. Throws if the token is malformed or the payload is not valid JSON. */
export function decodeJwt(token: string): IdTokenClaims {
  const [, payload] = token.split('.');
  return JSON.parse(atob(payload.replaceAll('-', '+').replaceAll('_', '/'))) as IdTokenClaims;
}

export function mapClaimsToUser(claims: IdTokenClaims): User {
  const firstName = claims.given_name ?? claims.email.split('@')[0];
  const lastName  = claims.family_name ?? '';
  return {
    firstName,
    lastName,
    name:             claims.name ?? `${firstName} ${lastName}`.trim(),
    email:            claims.email,
    initials:         `${firstName[0] ?? ''}${lastName[0] ?? ''}`.toUpperCase(),
    corporateAccount: claims.hd ?? '',
    countryIso:       '',
  };
}
